<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" style="width: 360px" />
          <a-button
            class="view-btn large"
            html-type="submit"
            @click="getDeptList"
            >搜索</a-button
          >
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表</sub-title>
      <ul class="handle-list" style="margin: -11px 0">
        <li class="handle-item" @click="showDept(null)">
          <a-icon type="form" class="u_svg_color" />
          <a href="javascript:;">新增</a>
        </li>
        <li class="handle-item" @click="delDeptByIds">
          <a-icon type="delete" class="u_svg_color" />
          <a href="javascript:;">删除</a>
        </li>
        <li class="handle-item" @click="getDeptList">
          <a-icon type="reload" class="u_svg_color" />
          <a href="javascript:;">刷新</a>
        </li>
      </ul>
    </div>
    <a-divider></a-divider>
    <!-- 列表表格 -->
    <a-table
      v-if="depts.length"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :columns="columns"
      :dataSource="depts"
      :rowKey="(record) => record.value"
      :loading="loading"
      :scroll="{ x: 1500, y: 600 }"
      :defaultExpandAllRows="true"
    >
      <template slot="operation" slot-scope="text, record">
        <a @click="showDept(record)" href="javascript:;">编辑</a> |
        <a @click="delDept(record.value)" href="javascript:;">删除</a>
      </template>
      <template slot="parentDept" slot-scope="text, record">{{
        parentDepts[record.parent_id] || "无"
      }}</template>
    </a-table>
    <!-- 列表表格 -->

    <!-- 新增/编辑 -->
    <a-modal
      centered
      title="编辑部门"
      v-model="edit_visible"
      :zIndex="2"
      width="720px"
      :maskClosable="false"
      @ok="save_handle"
    >
      <a-form class="modal-form" :form="form">
        <a-form-item
          label="上级部门"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-tree-select
            placeholder="请选择上级部门"
            :rows="4"
            :treeData="depts"
            treeDefaultExpandAll
            v-decorator="[
              'parent_id',
              { initialValue: dept && dept.parent_id },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="部门名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder="请输入部门名称"
            :rows="4"
            v-decorator="[
              'title',
              {
                initialValue: dept && dept.title,
                rules: [{ required: true, message: '部门名称不能为空' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="部门简称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder="请输入部门简称"
            :rows="4"
            v-decorator="[
              'simple_name',
              {
                initialValue: dept && dept.simple_name,
                rules: [{ required: true, message: '部门简称不能为空' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 新增/编辑 -->
  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { deptList, delDept, addDept, updDept } from "@/api";
import { getUserInfo } from "@/plugins/common";
export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal,
  },
  data() {
    return {
      // 显示列
      columns: [
        {
          title: "部门名称",
          width: 300,
          dataIndex: "title",
          key: "title",
        },
        {
          title: "部门简称",
          width: 200,
          dataIndex: "simple_name",
          key: "simple_name",
        },
        {
          title: "上级部门",
          width: 300,
          dataIndex: "parent_id",
          key: "parent_id",
          scopedSlots: { customRender: "parentDept" },
        },
        {
          title: "操作",
          key: "operation",
          width: 150,
          scopedSlots: { customRender: "operation" },
        },
      ],
      // 部门集合
      depts: [],
      parentDepts: {},
      loading: false,
      deling: false,
      edit_visible: false,
      dept: {},
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      user: {},
    };
  },
  mounted() {
    this.user = getUserInfo();
    // 考虑前端将扁平数据树形化，这样只用请求一次服务端
    this.getDeptList();
  },
  methods: {
    getDeptList() {
      deptList()
        .then((res) => {
          res.forEach((item, index) => {
            this.parentDepts[item.id] = item.name;
          });
          let parent_id = 0;
          if (this.user.id == 9707) {
            parent_id = 62;
          }
          this.depts = this.findChildren(res, parent_id);
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    findChildren(allDepts, current_pid) {
      let tmpdepts = [];
      allDepts.forEach((item, index) => {
        if (item.parent_id == current_pid) {
          let children = this.findChildren(allDepts, item.id);
          if (children) {
            item.children = children;
          } else {
            delete item.children;
          }
          tmpdepts.push({
            key: "" + item.id,
            value: "" + item.id,
            title: item.name,
            simple_name: item.simple_name,
            children: item.children,
            parent_id: "" + item.parent_id,
          });
        }
      });
      if (tmpdepts.length == 0) {
        return null;
      }
      return tmpdepts;
    },
    showDept(dept) {
      this.form.resetFields();
      this.dept = dept;
      this.edit_visible = true;
    },
    delDeptByIds() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.error("请选择您要删除的数据！");
        return;
      }
      this.delDept(this.selectedRowKeys.join(","));
    },
    delDept(ids) {
      //  console.log(ids);
      var self = this;
      Modal.confirm({
        title: "提示",
        content: "确定要删除吗？",
        centered: true,
        onOk() {
          if (self.deling) return;
          self.deling = true;
          delDept(ids)
            .then((res) => {
              self.selectedRowKeys = [];
              self.$message.success("删除成功");
              self.getDeptList();
            })
            .finally((res) => {
              self.deling = false;
            });
        },
      });
    },
    save_handle() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            name: values.title,
            simple_name: values.simple_name,
            parent_id: values.parent_id || 0,
          };
          if (this.dept && this.dept.value) {
            updDept(this.dept.value, params).then((res) => {
              this.$message.success("修改成功！");
              this.getDeptList();
              this.edit_visible = false;
            });
          } else {
            // add
            addDept(params).then((res) => {
              this.$message.success("添加成功！");
              this.getDeptList();
              this.edit_visible = false;
            });
          }
        }
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";
.other-filter {
  display: flex;
  height: 50px;
  align-items: center;
  .mr-20 {
    margin-right: 20px;
  }
}
</style>

